import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useToast from 'components/hooks/useToast';
import { activeGithubIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import { fetchGitUserDetails } from 'common/services/repositories.service';
import _ from 'lodash';

const useGitOrganizationForm = () => {
  const githubIntegrations = useSelector(activeGithubIntegrationsSelector);
  const integrationsCount = _.size(githubIntegrations);
  const toast = useToast();

  const [sensorAuthId, setSensorAuthId] = useState(null);
  const [githubOrgs, setGithubOrgs] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState(null);

  const initForm = () => {
    setGithubOrgs([]);
    setSelectedOrgName(null);
  };

  const autoSelectOneIntegration = () => {
    const firstIntegrationId = _.get(githubIntegrations, '[0].id');
    if (firstIntegrationId) setSensorAuthId(firstIntegrationId);
  };

  const loadGitUserDetails = async () => {
    try {
      initForm();
      const gitUserDetails = await fetchGitUserDetails(sensorAuthId);
      const userDetailsOrgs = _.get(gitUserDetails, 'orgs', []);
      const orderedOrgs = _.orderBy(
        userDetailsOrgs,
        'total_private_repos',
        'desc'
      );
      setGithubOrgs(orderedOrgs);
    } catch (err) {
      let errMsg = 'Failed to fetch organizations from GitHub. Please select a different integration or try again later';
      const responseCode = _.get(err, 'response.status', 500);
      if (responseCode === 401 || responseCode === 403) {
        errMsg = 'We were not able to access your Git account. Please select a different integration or try reauth your Git token';
      }
      setSensorAuthId(null);
      initForm();
      toast({
        message: errMsg,
        variant: 'error'
      });
    }
  };
  useEffect(() => {
    if (sensorAuthId) loadGitUserDetails();
  }, [sensorAuthId]);

  useEffect(() => {
    if (integrationsCount === 1) autoSelectOneIntegration();
  }, [githubIntegrations.length]);

  return {
    githubIntegrations,
    githubOrgs,
    sensorAuthId,
    setSensorAuthId,
    selectedOrgName,
    setSelectedOrgName
  };
};

export default useGitOrganizationForm;
